import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import * as S from './styles';
const NotAvailableBalance = ({ notAvailableMessage }) => (React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1 },
    React.createElement(S.StyledTooltip, { title: notAvailableMessage === null || notAvailableMessage === void 0 ? void 0 : notAvailableMessage.tooltipText, placement: "bottom-start" },
        React.createElement(InfoOutlinedIcon, null)),
    React.createElement(Typography, { fontSize: 16, fontWeight: 600 }, notAvailableMessage === null || notAvailableMessage === void 0 ? void 0 : notAvailableMessage.title)));
export default NotAvailableBalance;
//# sourceMappingURL=index.js.map